import React from 'react';
import { Link } from 'react-router-dom';
import { PiArrowLeftDuotone } from 'react-icons/pi';

const NAVIGATION_ARIA_LABEL = 'Навигация по разделу';
const BACK_ARIA_LABEL_PREFIX = 'Назад к разделу';
const TRAIL_SEPARATOR = '›';

const normalizeItems = (items) => (Array.isArray(items) ? items : []).filter((item) => item?.label);

const findParentItem = (items) => [...items]
  .slice(0, -1)
  .reverse()
  .find((item) => item.to);

const buildItemKey = (item, index) => `${item.to || 'current'}-${item.label}-${index}`;

/**
 * Breadcrumb — контекстная навигация вложенных экранов BetMate.
 *
 * @param {Array<{label: string, to?: string}>} items
 *   Последний элемент — текущая страница (без ссылки).
 */
const Breadcrumb = ({ items = [] }) => {
  const navigationItems = normalizeItems(items);
  const parentItem = findParentItem(navigationItems);

  if (navigationItems.length === 0) return null;

  return (
    <nav className="bm-breadcrumb" aria-label={NAVIGATION_ARIA_LABEL}>
      {parentItem?.to && (
        <Link
          to={parentItem.to}
          className="bm-breadcrumb__back"
          aria-label={`${BACK_ARIA_LABEL_PREFIX} ${parentItem.label}`}
        >
          <PiArrowLeftDuotone size={16} aria-hidden="true" focusable="false" />
          <span className="bm-breadcrumb__back-text">{parentItem.label}</span>
        </Link>
      )}

      <ol className="bm-breadcrumb__trail">
        {navigationItems.map((item, index) => {
          const isLast = index === navigationItems.length - 1;
          return (
            <li className="bm-breadcrumb__node" key={buildItemKey(item, index)}>
              {index > 0 && (
                <span className="bm-breadcrumb__sep" aria-hidden="true">
                  {TRAIL_SEPARATOR}
                </span>
              )}
              {isLast || !item.to ? (
                <span
                  className={isLast ? 'bm-breadcrumb__current' : 'bm-breadcrumb__item'}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="bm-breadcrumb__link">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
